<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj szablon' : 'Dodaj szablon' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa szablonu*" />
          </w-schema>
        </v-flex>

        <v-flex md12>
          <v-layout row wrap>
            <v-flex pr-2 xs12 md6>
              <w-schema :model="$schema.fromName">
                <v-text-field name="fromName" label="Nazwa nadawcy*" />
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs12 md6>
              <w-schema :model="$schema.fromAddress">
                <v-text-field name="fromAddress" label="E-mail nadawcy*" />
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.to">
            <v-text-field name="to" label="Odbiorca" />
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.subject">
            <v-text-field name="subject" label="Temat*" />
          </w-schema>
        </v-flex>

        <v-flex class="mb-4">
          <html-editor :schema="$schema.body" :code-editor="true" />
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { ProfileType } from '@witkac/kartamiejska-shared';
import { WSchema } from '@witkac/vuetify-components';

import HtmlEditor from '@/components/forms/HtmlEditor';
import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/mailTemplate.schema';

const emptyData = () => ({
  name: '',
  subject: '',
  fromName: '',
  fromAddress: '',
  to: '',
  body: ''
});

export default {
  components: { modal, HtmlEditor, WSchema },
  mixins: [manageMixin('mailTemplates', {}, emptyData)],
  schema
};
</script>
